import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$container = this.$('container')[0]
        this.$prevButton = this.$('prev')[0]
        this.$nextButton = this.$('next')[0]

        // Data
        this.length = this.$('item').length
    }

    //////////////
    // Lifecycle
    //////////////
    init() {
        Swiper.use([Navigation, A11y])

        const args = {
            speed: 700,
            a11y: true,
            loop: false,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1,
            navigation: {
                prevEl: this.$prevButton,
                nextEl: this.$nextButton,
            }
        }

        this.carousel = new Swiper(this.$container, args)
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
    }
}
